const locale = {
  // message: 'hello ext',

  server: {
    INTERNAL_SERVER_ERROR: 'Internal server error',
    FORBIDDEN: 'Forbidden',
    JWT_EXPIRED: 'Your token is expired',

    // Authn
    INVALID_CREDENTIALS: 'Login or password is not valid.',
    VALIDATION_ERROR: 'Validation Error',
    NOT_FOUND: 'Not found',
    LINK_EXPIRED: 'Link expired',
    SESSION_EXPIRED: 'Session expired',
    PASSWORD_RESET_EMAIL_SENT: 'Password reset email sent',
    PASSWORD_UPDATED: 'Password updated',
    LOGOUT_SUCCESS: 'Logout success',
    EMAIL_VERIFIED: 'Email verified',
    VERIFY_EMAIL_SENT: 'Email sent',
    VERIFY_COUNT_OVER: 'Your request count is over limit',

    // Authz
    PERMISSION_NOT_FOUND: 'Permission not found',
    ROLE_NOT_FOUND: 'Role not found',

    // Asset
    ASSETS_CREATED: 'Assets created successfully!',
    ASSET_NOT_FOUND: 'Asset not found',
    ASSET_UPDATED: 'Asset updated',
    ASSETS_CREATED_LIMITED: 'Assets created limited',
    ASSET_NOT_CREATED: 'Asset not created',
    NO_FILEPATH: 'No filepath',
    FILESIZE_LIMIT_EXCEED: 'Your file size exceeded limit.',

    // Membership
    MEMBERSHIP_NOT_FOUND: 'Membership not found',
    MEMBERSHIPID_NOT_FOUND: 'Membership ID not found',
    RESOURCE_NOT_FOUND: 'Resource not found',
    WRONG_PERMISSION: 'Wrong permission',
    PLANID_NOT_FOUND: 'Plan ID not found',

    // Payment
    BALANCE_NOT_LOADED: 'Balance not loaded',
    CUSTOMER_NOT_LOADED: 'Customer not loaded',
    CUSTOMER_DELETED: 'Customer deleted',
    NOTHING_CHANGED: 'Nothing changed',
    CARD_CREATED: 'Card created',
    NEWCARD_NOT_ADDED: 'New card not added',
    CARD_DELETED: 'Card deleted',
    CARD_NOT_DELETED: 'Card not deleted',
    CARD_UPDATED: 'Card updated',
    CARD_NOT_UPDATED: 'Card not updated',
    PAYMENT_NOT_FOUNDED: 'Payment not founded',
    FREEMEMBERSHIP_NOT_ALLOWED: 'Free membership not allowed',

    // Subscription
    USER_NOT_UPDATED: 'User not updated',
    SUBSCRIPTION_CREATED: 'Subscription created',
    SUBSCRIPTION_NOT_CREATED: 'Subscription not created',
    SUBSCRIPTION_CANCELDED: 'Subscription cancelled',
    SUBSCRIPTION_NOT_CANCLED: 'Subsciption not cancelled',
    SUBSCRIPTION_UPDATED: 'Subscription updated',
    SUBSCRIPTION_NOT_UPDATED: 'Subscription not updated',
    CHARGE_CREATED: 'Charge created',
    CHARGE_NOT_CREATED: 'Charge not created',
    NO_SUBSCRIPION_ID: 'No subscription ID',
    INVALID_STRIPE_CALL: 'Invalid stripe call',

    // Tour
    TOUR_CREATED: 'Tour created',
    TOUR_NOT_FOUND: 'Tour not found',
    UPLOAD_CREDENTIALS_GENERATED: 'Upload credentials generated',
    EXCEED_MAX_PROJECT: 'Exceed max project',
    LIMIT_EXCEED: 'Limit exceed',

    // User
    USER_CREATED: 'User created',
    USER_NOT_FOUND: 'User not found',
    USER_REGISTERED: 'User registered',
    USER_VERIFIED: 'User verified',
    PASSWORD_CHANGED: 'Password changed',
    PERRMISSION_DENIED: 'Permission denied',

    // Addon
    // NOT_FOUND: '',
    ADDON_NOT_FOUND: 'Addon not found',
    ADDONID_NOT_FOUND: 'Addon ID not found',
    DUPLICATED_ADDON: 'Duplicated addon',

    // Statistic
    USER_STATISTICS_NOT_FOUND: 'User statistic not found',
    ASSETS_STATISTICS_NOT_FOUND: 'Assets statistic not found',
    TOUR_STATISTICS_NOT_FOUND: 'Tour statistics not found',
    STAT_SAVED: 'Statistic saved',

    // Hotspot
    HOTSPOT_CREATED: 'Hotspot created',
    HOTSPOT_NOT_FOUND: 'Hotspot not found',
    INVALID_URL: 'Invalid URL',

    // icon
    ICON_NOT_CREATED: 'Icon not created',
    ICON_NOT_FOUND: 'Icon not found',

    // Scene
    SCENE_CREATED: 'Scene created',
    SCENE_NOT_CREATED: 'Scene not created',
    SCENE_NOT_FOUND: 'Scene not found',
    SCENES_CREATED_LIMITED: 'Scenes created limited',

    // Section
    SECTION_CREATED: 'Section created',
    SECTION_NOT_CREATED: 'Section not created',
    SECTION_NOT_FOUND: 'Section not found'
  },
  login: {
    login: 'Login',
    facebook: 'Login with Facebook',
    google: 'Login with Google',
    divider: 'OR',
    idPlaceholder: 'Email or Username',
    passwordPlaceholder: 'Password',
    loginDesc: 'Log in to your Account',
    forgotPassword: 'Forgot password',
    register: 'Do not have account?',
    havePreviousAccount: 'Do you have previous account?',
    havePreviousAccountDesc: 'Even though you have previous account, you have to register new account.',

    errors: {
      invalidCredential: 'Invalid Email/Username or Password!',
      notVerifiedEmail: 'Plase verify your email first!'
    }
  },

  forgotPassword: {
    recoverDesc: 'Recover your Password',
    emailPlaceholder: 'Email',
    reset: 'Send reset link',
    goBack: 'Go back to login'
  },

  resetPassword: {
    resetDesc: 'Reset your Password',
    passwordPlaceholder: 'Password',
    confirmPlaceholder: 'Confirm Password',
    reset: 'Reset'
  },

  register: {
    registerDesc: 'Create an Account',
    facebook: 'Join with Facebook',
    google: 'Join with Google',
    divider: 'OR',
    usernamePlaceholder: 'Username',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    confirmPlaceholder: 'Confirm Password',
    accept: 'I read and accept {0}',
    terms: 'terms and conditions',
    createAccount: 'Create Account',
    goBack: 'Already have an account?',
    registed: 'Email sent to your email address! Please check your email!',

    errors: {
      notUnique: 'This {field} is already taken',
      invalidEmail: 'Please provide valid email address',
      invalidUsername: 'Please provide valid username with only number and alphabet'
    }
  },

  verify: {
    success: 'Your account verified now!',
    fail: 'Expired or not exist resources.'
  },

  sider: {
    tours: 'VR Tours',
    profile: 'Profile',
    cloud: 'Cloud',
    account: 'Account',
    analytic: 'Analytic',
    billing: 'Billing',
    upgrade: 'Upgrade'
  },

  toolbar: {
    guide: 'Guide',
    tourPlaceholder: 'Search all tours',
    assetPlaceholder: 'Search all assets',
    myPage: 'My page',
    adminPanel: 'Admin Panel',
    logout: 'Logout'
  },

  account: {
    upgrade: 'Upgrade',
    upgradeDesc: 'Upgrade package to enjoy more benefits!',
    membershipPackage: 'Membership Package',
    numberOfScenes: 'Max size of each scene',
    perMonth: 'MB',
    numberOfTours: 'Max size of each tour',
    availableFeatures: 'Available Features',
    cancelSubscription: 'Cancel Subscription',
    subscriptionCancelsAt: '{day} days remain until cancel',
    password: 'Password',
    passwordDesc: 'Change your login password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordSave: 'Save',
    personalInfo: 'Personal Information',
    personalDesc: 'YouVR membership is for single agent use only. <br> Please sign up for enterprise package for multiple users',
    title: 'Title',
    firstName: 'First Name',
    surname: 'Last Name',
    birthdate: 'Birthdate',
    contactUs: 'If any of above details are incorrect, please contact us.',
    billingAddress: 'Billing Address',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    infoSave: 'Save',
    passwordChangeTitle: 'Are you sure to change your password?',
    passwordChangeDesc: 'You will be logouted all of your devices. Please make sure.'
  },

  analytic: {},

  billing: {
    pastTransactions: 'Past Transactions',
    ref: 'Ref#',
    description: 'Description',
    result: 'Result',
    paymentMethod: 'Payment Method',
    date: 'Date',
    amount: 'Amount',
    pdf: 'PDF File'
  },

  assetCard: {
    viewAsset: 'View asset'
  },

  assetTopLayer: {
    uploadPano: '+ Upload Panoramas',
    uploadPanoMobile: '+ Upload',
    remain: 'Total assets',
    unselectAll: 'Unselect All',
    selectAll: 'Select All',
    download: 'Download',
    delete: 'Delete',
    UploadPanoTitle: 'Upload Panoramas',
    bulkDeleteTitle: 'Are you sure you want to delete?',
    bulkDeleteDesc: 'The selected assets will be deleted permanantly.',
    noUploadList: 'There is no image to upload.'
  },

  cloud: {
    noAsset: 'You don’t have any assets :’(',
    panoramas: 'Panoramas',
    deleteTitle: 'Are you sure you want to delete?',
    deleteDesc: 'The selected asset will be deleted permanantly.',
    noAssetTitle: 'You have no panoramas uploaded',
    noAssetButton: 'Get started'
  },

  panoViewer: {},

  filtersLayer: {
    remain: 'Total tours'
  },

  quote: {
    quote0: '<a href="https://support.youvr.io/knowledge" target="_blank">Unsure of how to start creating VR tours? Click here to visit the support center.</a>',
    quote1: 'Discover and unlock paid features in the upgrade page!',
    quote2: 'Thank you for Signing up. Create unlimited tours for free today!'
  },

  shareModal: {
    shareTitle: 'Share Tour',
    socialMedia: 'Social Media',
    copyUrl: 'Copy URL',
    privateUrl: 'Private URL',
    publicUrl: 'Public URL',
    datePlaceholder: 'Select Date',
    embedCode: 'Embed Code',
    qrCode: 'QR Code',
    size: 'Size'
  },

  uploadProgress: {
    success: 'Success!',
    uploading: 'Uploading...'
  },

  floorplan: {},

  cardList: {
    paymentDetails: 'Payment Details',
    savedPaymentMethod: 'Saved Payment Method',
    expired: 'Expired at {month} / {year}',
    addNewCard: 'Add a new credit card',
    cardNumber: 'Credit or debit card',
    cardName: 'Name on Card',
    cardCountry: 'Country / Region',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    saveCard: 'Save',
    deleteCardTitle: 'Are you sure to delete your card?',
    deleteCardDesc: 'If you click OK, then this card will be deleted'
  },

  payment: {
    orderSummary: 'Order Summary',
    package: 'Package',
    goBack: 'Back',
    confirm: 'Confirm Payment',
    analytics: '+ Analytics add on',
    groupManagement: '+ Group Management add on',
    liveShare: '+ Live Share',
    totalPrice: 'Total Price',
    paymentSuccessTitle: 'Success',
    paymentSuccessDesc: 'Payment Succeeded, token will be changed'
  },

  profile: {
    agencyInfo: 'Agency Information',
    agencyInfoDesc: 'This information will appear in all your VR Tours',
    officeName: 'Agency Name',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    sameAsBillingAddress: 'same as billing address',
    officeNumber: 'Office Number',
    officeEmail: 'Email Address',
    officeWebsite: 'Website',
    picture: 'Profile Picture',
    pictureDesc: 'This picture will appear all your VR Tours',
    noPicture: 'Upload Photo',
    pictureProtocol: 'PNG or JPEG, 130 x 130 px',
    nadir: 'Company Logo',
    nadirDesc: 'Logo will appear in all your VR Tours on the floor of each scene',
    noNadir: 'Upload Logo',
    nadirProtocol: 'PNG or JPEG, 200 x 200 px',
    saveProfile: 'Save Changes',
    preview: 'Preview',

    errors: {
      noUploadCredential: 'No upload credential in {field}'
    }
  },

  tour: {
    published: 'Published',
    drafts: 'Drafts',
    deleted: 'Recently Deleted'
  },

  tourCard: {
    viewTour: 'View Tour',
    present: 'Present',
    duplicate: 'Duplicate',
    floorplan: '3D Floorplan',
    share: 'Share',
    edit: 'Edit',
    restore: 'Restore',
    delete: 'Delete',
    deletePermanently: 'Delete Permanently',
    more: 'More',
    processing: 'Processing',
    cancel: 'Cancel',
    cancelProcessTitle: 'Are you sure to cancel your process?',
    cancelProcessDesc: 'All of your process will be initialized'
  },

  tourList: {
    unselectAll: 'Unselect All',
    selectAll: 'Select All',
    moveToDrafts: 'Move to Drafts',
    publish: 'Publish',
    restore: 'Restore',
    deletePermanently: 'Delete Permanently',
    delete: 'Delete',
    noTourTitle: 'Welcome to Tour Creator',
    noTourDesc: 'Click the button below to create your first VR tour',
    noTourButton: 'Get Started'
  },

  tourCreator: {
    title: 'Create New Tour',
    propertyTitle: 'Tour Title',
    publicTitle: 'Public Title',
    publicTitleDesc: 'Display generic property title',
    propertyType: 'Property Type',
    description: 'Description',
    floors: 'Floors',
    bedrooms: 'Bedrooms',
    area: 'Area',
    transaction: 'Transaction',
    price: 'Price',
    location: 'Location',
    searchPlaceholder: 'search',
    descriptionPlaceholder: 'Enter something...',
    addressPlaceholder: 'Address (Can pick only on the map)',
    detailAddressPlaceholder: 'Detail address',
    hideAddressDesc: 'Display/Hide address',
    cancel: 'Cancel',
    submit: 'Submit'
  },

  upgrade: {
    step0: 'Choose Upgrade',
    step1: 'Add-Ons',
    step2: 'Payment',
    yearlySubscription: '12 month subscription',
    freeForever: 'free forever',
    perMonth: 'per month',
    freePurpose: 'Tour Creator, 3D Home App',
    freeFeature1: 'YouVR branding',
    freeFeature2: 'Advertisement banner',
    active: 'Upgrade',
    activated: 'Active',
    proPurpose: 'Tour Creator, 3D Home App, Add-ons: 2D Floorplan & 3D Dollhouse, Virtual home staging',
    proFeature1: 'Customized Branding',
    proFeature2: 'No Advertisement',
    enterprise: 'Enterprise',
    enterprisePrice: 'Let\'s talk',
    enterpriseUnit: 'custom package',
    enterprisePurpose: 'Customization for your business',
    enterpriseFeature1: 'White Label',
    enterpriseFeature2: 'API Integration',
    enterpriseFeature3: 'Customized VR tour app',
    enterpriseFeature4: 'Downloadable VR tour',
    enterpriseContactUs: 'Contact Us',
    added: 'Added',
    add: 'Add',
    package: 'Package'
  },

  common: {
    state: {
      success: 'Success to {action} {object}',
      fail: 'Fail to {action} {object}'
    },
    errors: {
      empty: '{field} cannot be empty',
      min: '{field} length should be at least {length} words',
      max: '{field} length cannot be more than {length} words',
      type: '{field} type should be a {type}',
      invalid: 'Please check up all fields!',
      confirm: 'Confirm password is different with new password',
      internal: 'Sorry for inconvenience, there is a system error.',
      strength: 'Please check your password strength.'
    }
  }
};

export default locale;
